import { render, staticRenderFns } from "./MethodHelp.vue?vue&type=template&id=0c9def7c"
import script from "./MethodHelp.vue?vue&type=script&lang=js"
export * from "./MethodHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports